<template>
  <div>
    <v-dialog
      :value="show"
      persistent
      scrollable
      :fullscreen="$vuetify.breakpoint.xs"
      lazy
      :width="
        hasMultipleMenuTemplates
          ? $store.state.common.extraLargeDialogWidth
          : $store.state.common.largeDialogWidth
      "
      @input="(val) => $emit('update:show', val)"
    >
      <v-card>
        <v-card-title class="pb-0 d-block">
          <v-layout align-center>
            <v-layout
              v-if="menuItem"
              align-center
              wrap
            >
              <div class="headline mb-2 d-flex">
                <img
                  src="/static/icon_krone_01.svg"
                  width="28"
                  height="28"
                  class="mr-2"
                  :class="[
                    menuItem.is_highlight ? 'filter-to-msr-color-primary' : '',
                  ]"
                  style="display: inline-flex"
                >
                {{ $t('menuItemHighlightDialogTitlePrefix') }}:
                {{ menuItem.name }}
              </div>
            </v-layout>
            <v-btn
              class="ml-auto mr-0 my-0"
              flat
              icon
              :title="$t('close')"
              @click="close()"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-layout>
          <div class="subheading">
            {{ $t('menuItemHighlightDialogHint') }}
          </div>
        </v-card-title>
        <v-card-text>
          <!-- Loading Indicator -->
          <div
            v-if="loading"
            class="loading-indicator mt-3"
          >
            <v-progress-circular
              :size="50"
              indeterminate
              class="msr--text"
            />
          </div>
          <!-- Previews -->
          <v-layout
            v-else
            :justify-center="!hasMultipleMenuTemplates"
            wrap
          >
            <div
              v-for="(
                payload, payloadIndex
              ) in menuItemHighlightPreviewPayloads"
              :key="show + menuItem.id + payload.menu_template.id"
            >
              <tv-template-preview
                ref="highlight-previews"
                class="mt-3 mr-3 elevation-3"
                :html-overlay="payload.menu_template.html_overlay"
                :width="payload.menu_template.tvformat.width"
                :height="payload.menu_template.tvformat.height"
                :max-width="previewMaxWidth"
                :max-height="previewMaxWidth"
                :duration="payload.menu_template.duration"
                :onload-callback="
                  () =>
                    populateHighlightPreviewIframeWithOverlayData(
                      payload,
                      payloadIndex
                    )
                "
              />
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout
            column
            justify-center
            align-center
          >
            <div
              v-if="!menuItem.image"
              class="subheading mb-1"
            >
              <router-link
                :to="{
                  name: 'editmenuitem',
                  params: {menuItemId: menuItem.id},
                  query: {menu: menuId},
                }"
              >
                {{ $t('menuItemHighlightDialogNoImageWarning') }}
              </router-link>
            </div>
            <v-switch
              :disabled="!menuItem.image || busy"
              :loading="busy"
              style="flex-grow: 0; flex-basis: fit-content"
              color="msr"
              class="mt-0"
              :label="$t('menuItemIsNotHighlightTooltip')"
              :input-value="menuItem.is_highlight"
              @change="$emit('change', !menuItem.is_highlight)"
            />
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import TvTemplatePreview from '@/components/TvTemplatePreview';

export default {
  components: {
    TvTemplatePreview,
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    menuItem: {
      type: Object,
      required: true,
    },
    menuId: {
      type: Number,
      required: true,
    },
    busy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      menuItemHighlightPreviewPayloads: null,
    };
  },
  computed: {
    hasMultipleMenuTemplates() {
      return (
        this.menuItemHighlightPreviewPayloads &&
        this.menuItemHighlightPreviewPayloads.length > 1
      );
    },
    previewMaxWidth() {
      if (this.hasMultipleMenuTemplates) {
        // This should still fit 16:9 and 9:16 previews side by side.
        return 520;
      }
      return 560;
    },
  },
  watch: {
    show: function (show) {
      if (show) {
        this.fetchMenuItemHighlightPreviewPayloads();
      }
    },
  },
  methods: {
    fetchMenuItemHighlightPreviewPayloads() {
      this.loading = true;
      this.$api
        .getMenuItemHighlightPreviews(this.menuItem.id)
        .then((response) => {
          this.menuItemHighlightPreviewPayloads = response.data;
        })
        .finally(() => (this.loading = false));
    },
    populateHighlightPreviewIframeWithOverlayData(
      menuItemHighlightPayload,
      widgetIndex
    ) {
      const previewWidgets = this.$refs['highlight-previews'];
      const previewWidget = previewWidgets[widgetIndex];
      if (!previewWidget) {
        return;
      }
      const overlayData = {
        menu_item_highlight: menuItemHighlightPayload,
      };
      previewWidget.updateOverlayData(overlayData);
    },
    close() {
      this.$emit('update:show', false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Menu/HighlightMenuItemDialog.vue